import styled from "@emotion/styled";

const PageSectionWrapper = styled.section`
    label: PageSectionWrapper;

    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;

    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        flex-direction: column;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        flex-direction: column;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        flex-direction: column;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        flex-direction: column;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        flex-direction: row;
        ${({ direction }) => (direction === "content-left" ? "flex-direction: row;" : "flex-direction: row-reverse;")}
        ${({ pageTitle }) => (pageTitle ? "font-size: 3.125rem;" : "font-size: 2.25rem;")}
    }
    ${({ pageTitle }) => (pageTitle ? "align-items: flex-start;" : "align-items: center;")}
`;

export default PageSectionWrapper;
